export const KYC_STATUS_ATTEMPT = 'KYC_STATUS_ATTEMPT';
export const KYC_STATUS_FAILURE = 'KYC_STATUS_FAILURE';
export const KYC_STATUS_SUCCESS = 'KYC_STATUS_SUCCESS';

export const CLEAR_KYC_STATE = 'CLEAR_KYC_STATE';
export const CLEAR_STATE = 'CLEAR_STATE';
